<script>
import 'intersection-observer'

export default {
  name: 'VisibilityObserver',

  props: {
    threshold: {
      type: Array | Number,
      required: false,
      default: () => [0, 0.2],
    },

    root: {
      type: HTMLElement,
      required: false,
      default: () => null,
    },

    rootMargin: {
      type: String,
      required: false,
      default: '0px 0px 0px 0px',
    },
  },

  data() {
    return {
      observer: new IntersectionObserver(
        (entries, observer) => {
          const entry = entries[0]

          if (!entry.isIntersecting) {
            this.$emit('unvisible', this)
          } else {
            this.$emit('visible', this)
          }

          this.$emit('change', this)
        },
        {
          threshold: this.threshold,
          root: this.root,
          rootMargin: this.rootMargin,
        },
      ),
    }
  },

  render(createElement) {
    const defaultSlot = this.$slots.default

    if (defaultSlot.length === 1) return defaultSlot[0]

    return createElement('div', defaultSlot)
  },

  mounted() {
    this.observe()
  },

  destroyed() {
    this.unobserve()
  },

  methods: {
    observe() {
      this.observer.observe(this.$el)
    },

    unobserve() {
      this.observer.disconnect()
    },
  },
}
</script>
